import React, {useCallback, useContext, useState} from 'react';
import {Popup, Input, toast, setOptions, Button} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import '../styles/dashboardWorkspaceRename.css';
import Empty from "../utils/Empty";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/pro-duotone-svg-icons";
import Loading from "../utils/Loading";
import {NetworkContext} from "../utils/NetworkContext";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function DashboarWorkspaceRename({locale, dialog, Dialog, width, workspaceItemDialog, teamtalk, navigation, setWorkspaceItemDialog}) {
    const {wsCall} = useContext(NetworkContext);
    const [name, setName] = useState(workspaceItemDialog.name);
    const [saving, setSaving] = useState(false);

    const DialogClose = useCallback(() => {
        Dialog({view: 'close'});
    }, [Dialog]);

    const ButtonSave = () => {
        if (!name) {
            toast({message: locale.dashboardWorkspaceRename.c, color: 'danger', display: 'bottom', duration: 3000});
        } else if (name) {
            setSaving(true);

            const message = {
                type: 'wss',
                path: 'workspace-name',
                action: 'update',
                data: {
                    id: workspaceItemDialog.id,
                    name: name,
                    teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id, users: teamtalk.users} : null,
                    tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
                }
            };
            wsCall(message);
        }
    }

    const ButtonClose = () => {
        setWorkspaceItemDialog({});
        Dialog({view: 'dashboardWorkspace', tab: 'workspace'});
    }

    return (
        <Popup className="cs-dashboard-workspace-rename-popup" width={600} display="center" scrollLock={true} closeOnOverlayClick={false} closeOnEsc={false} buttons={[]} isOpen={dialog.view === 'dashboardWorkspaceRename'} onClose={DialogClose}>
            <div className="mbsc-grid cs-dashboard-workspace-rename-header-col">
                <div className="mbsc-row cs-dashboard-workspace-rename-header-row">
                    {width > 576 &&
                        <div className="mbsc-col cs-dashboard-workspace-rename-header-col" />
                    }
                    <div className={width > 576 ? "mbsc-col cs-dashboard-workspace-rename-header-col mbsc-align-center" : "mbsc-col cs-dashboard-workspace-rename-header-col"} >
                        <Button className="cs-dashboard-workspace-rename-title-button mbsc-bold mbsc-txt-muted" variant="flat" >
                            {locale.dashboardWorkspaceRename.e}
                        </Button>
                    </div>
                    <div className="mbsc-col cs-dashboard-workspace-rename-header-col mbsc-align-right">
                        <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-workspace-rename-close-button" onClick={() => ButtonClose()} >
                            &nbsp;<FontAwesomeIcon className="cs-dashboard-workspace-rename-close-icon" icon={faXmark} />
                        </Button>
                    </div>
                </div>
            </div>
            {!saving &&
                <Input inputStyle="underline" label={locale.dashboardWorkspaceRename.b} labelStyle="floating" type="text" name="account" value={name} onChange={ev => setName(ev.target.value)} />
            }
            {saving &&
                <Loading />
            }
            {!saving &&
                <div className="mbsc-button-group-justified cs-dashboard-workspace-rename-nav-buttons">
                    <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-workspace-rename-nav-button" onClick={() => ButtonSave()} >
                        {locale.dashboardWorkspaceRename.a}
                    </Button>
                </div>
            }
        </Popup>
    );
}

export default DashboarWorkspaceRename;
